import React from "react";
import { Flex, Text } from "@chakra-ui/react";

const VisualizarInfo = ({ title, info, bgColor }) => {
  return (
    <Flex px="15px" py="10px" w="100%" bgColor={bgColor} alignItems="flex-start">
      <Text
        fontWeight={500}
        fontSize="16px"
        lineHeight="21.6px"
        color="#797A80"
        width={{ base: "20%", sm: "200px", xl: "380px" }}
        minWidth="max-content"
        title={title}
        data-testid="title"
      >
        {title}
      </Text>
      <Text fontWeight={400} fontSize="16px" lineHeight="19.6px" ml="15px" flex={1} whiteSpace="pre-wrap">
        {info}
      </Text>
    </Flex>
  );
};

export default VisualizarInfo;
